import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "./contract.css";

const Contract = () => {
  const [selected, setSelected] = useState("nonnegotiation");
  const navigate = useNavigate();

  const handleContinue = () => {
    if (selected === "negotiation") {
      navigate("/client-portal/negotiation-contract/create");
    } else {
      navigate("/client-portal/sleeve");
    }
  };

  const onClose = () => {
    navigate("/client-portal");
  };


  return (
    <div className="contract-modal-overlay">
      <div className="contract-modal">
        <button className="close-btn" onClick={onClose} aria-label="Close modal">
          &times;
        </button>

        <h2 className="contract-title">
          Choose Your Contract Type <span>✨</span>
        </h2>
        <p className="contract-subtitle">
          Select the most suitable workflow to create and manage your contract efficiently.
        </p>

        <div className="contract-options">
          {/* Non-Negotiation Contract */}
          <div
            className={`contract-option ${selected === "nonnegotiation" ? "selected" : ""}`}
            onClick={() => setSelected("nonnegotiation")}
            tabIndex={0}
            role="button"
          >
            <div className="radio">
              <div className={`radio-inner ${selected === "nonnegotiation" ? "active" : ""}`} />
            </div>
            <h3 className="option-title">Non-Negotiation Contract</h3>
            <span className="option-tag">Quick Execution</span>
            <p className="option-desc">
              Perfect for standard agreements. Use approved templates,
              skip negotiations, and finalize contracts in just a few clicks.
            </p>
          </div>

          {/* Negotiation Contract */}
          <div
            className={`contract-option ${selected === "negotiation" ? "selected" : ""}`}
            onClick={() => setSelected("negotiation")}
            tabIndex={0}
            role="button"
          >
            <div className="radio">
              <div className={`radio-inner ${selected === "negotiation" ? "active" : ""}`} />
            </div>
            <h3 className="option-title">Negotiation Contract</h3>
            <span className="option-tag">Collaborative Workflow</span>
            <p className="option-desc">
              Work together with your team and counterparties in real time.
              Review, comment, and refine contract terms seamlessly before final approval.
            </p>
          </div>
        </div>

        <button className="contract-button" onClick={handleContinue}>
          Continue <span role="img" aria-label="rocket">🚀</span>
        </button>
      </div>

    </div>
  );
};

export default Contract;
